<div [ngClass]="['title-textarea', classDiv, isDisabled()]">
  <h5 class="title-textarea__title">{{ title }}</h5>
  <textarea
    autocomplete="off"
    matInput
    [ngClass]="['title-textarea__area']"
    [formControl]="textAreaControl">
  </textarea>
  <app-error-message [inputVal]="textAreaControl"></app-error-message>
</div>
